// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"U8-z"};